import React, { useState } from 'react'
import { Input, Select, Modal, Spin, Button, message } from 'antd'
import { createProductionMethods } from '../../../../services/api/apiProductionMethods'

function CreateProductionMethod(props) {
    const { disabled, reset } = { ...props }
    const [showCreate, setShowCreate] = useState(false)
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState('')
    const [code, setCode] = useState('')
    const [partner, setPartner] = useState('')
    const [error, setError] = useState('')

    const closeCreateModal = () => {
        setShowCreate(false)
        setName('')
        setCode('')
        setPartner('')
        setError('')
    }

    const handeShowCreateModal = () => {
        setShowCreate(true)
    }


    const handleChangeInput = (field, e) => {
        if (field === 'name') {
            setName(e.target.value)
        }
        if (field === 'code') {
            setCode(e.target.value)
        }
    }

    const handleChangePartner = (value) => {
        setPartner(value)
    }

    const handleCreate = async () => {
        setError('')
        setLoading(true)
        const payload = {
            name: name ? name.trim() : '',
            code: code ? code.trim() : '',
            partner: partner ? partner.trim() : '',
        }
        try {
            const { success, message: mess } = await createProductionMethods(payload)
            if (!success) {
                throw new Error(mess)
            }
            message.success('Phương pháp sản xuất được tạo thành công!')
            closeCreateModal()
            reset()
        } catch (error) {
            message.error(error.message)
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const disabledOkBtn = !name.trim() || !code.trim() || !partner.trim()

    const partnerOptions = [
        { label: 'BINH MINH', value: 'BINH MINH', },
        { label: 'QUANG MINH', value: 'QUANG MINH', },
        { label: 'TOÀN CẦU', value: 'TOÀN CẦU', },
    ]

    return (
        <div className='CreateProductionMethod'>
            <Button disabled={disabled} onClick={handeShowCreateModal} className='btn btn-primary'>Thêm mới</Button>
            <Modal
                width="600px"
                className="CreateModal"
                title="Thêm mới phương pháp sản xuất"
                visible={showCreate}
                onOk={handleCreate}
                onCancel={closeCreateModal}
                okText='Thêm mới'
                okButtonProps={{ disabled: disabledOkBtn, className: 'rounded' }}
                cancelText='Hủy'
                cancelButtonProps={{ disabled: loading, className: 'rounded' }}
                closable={!loading}
                maskClosable={!loading}
                confirmLoading={loading}
            >
                <Spin spinning={loading} tip='Loading...' size='large' >
                    <div className="createForm mt-3 mb-3">
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Tên</label>
                            <Input
                                placeholder='Nhập tên ...'
                                onChange={(e) => handleChangeInput('name', e)}
                                value={name || ''}
                                allowClear
                            />
                        </div>
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Mã hóa</label>
                            <Input
                                placeholder='Nhập mã ...'
                                onChange={(e) => handleChangeInput('code', e)}
                                value={code || ''}
                                allowClear
                            />
                        </div>
                        <div className="createFormItem d-flex align-items-center mb-3">
                            <label className='font-weight-bold mb-0' style={{ minWidth: '117px' }} >Partner</label>
                            <Select
                                placeholder='Partner sản xuất ...'
                                onChange={handleChangePartner}
                                value={partner || []}
                                allowClear
                                showArrow
                                showSearch
                                style={{ width: '100%' }}
                                options={partnerOptions}
                            />
                        </div>
                    </div>
                    {error &&
                        <span className="noti-error text-danger d-block mb-1">{error}</span>
                    }
                </Spin>
            </Modal>
        </div>
    )
}

export default CreateProductionMethod